import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useDropzone } from 'react-dropzone';

const StyledRoot = styled('div')({
    color: '#999',
    cursor: 'pointer',
    padding: '1rem',
    background: '#efefef',
    textAlign: 'center',
});

const StyledInput = styled('input')({
    display: 'none',
});

const StyledDropzoneMessage = styled(Typography)({
    fontSize: '16px',
});

const VideoUploaderDropzone = ({ onFileSelected }) => {
    const handleDrop = React.useCallback((files) => {
        onFileSelected(files[0]);
    }, [onFileSelected]);

    const {
        getRootProps,
        getInputProps,
    } = useDropzone({
        onDrop: handleDrop,
        multiple: false,
        accept: {
            'video/*': ['.mp4', '.mpeg'],
        },
    });

    return (
        <StyledRoot {...getRootProps({ id: 'direct-upload-dropzone' })}>
            <StyledInput {...getInputProps()} />
            <StyledDropzoneMessage
                variation="body1"
                align="center"
                color="textSecondary"
            >
                Drop a file to upload, or click to select it.
            </StyledDropzoneMessage>
        </StyledRoot>
    );
};

VideoUploaderDropzone.propTypes = {
    onFileSelected: PropTypes.func.isRequired,
};

export default VideoUploaderDropzone;
